import type { Entry } from "../api/schemas/entries";

/** The record's memory, derived from its entries (KTD7); shared by the Record and Capture pages. */

export type Task = { id: string; text: string; completed: boolean };

export const parseTasks = (entry: Entry): ReadonlyArray<Task> => {
	if (entry.type !== "tasks" || !entry.json) return [];
	try {
		const tasks = (JSON.parse(entry.json) as { tasks?: unknown }).tasks;
		return Array.isArray(tasks)
			? tasks.filter(
					(t): t is Task =>
						typeof t === "object" &&
						t !== null &&
						typeof (t as Task).text === "string",
				)
			: [];
	} catch {
		return [];
	}
};

/** Every unfinished task across the record's task entries. */
export const openTasksOf = (
	entries: ReadonlyArray<Entry>,
): ReadonlyArray<Task> =>
	entries.flatMap(parseTasks).filter((task) => !task.completed);

/** The newest non-task entry by timestamp. */
export const lastEntryOf = (entries: ReadonlyArray<Entry>): Entry | undefined =>
	entries
		.filter((entry) => entry.type !== "tasks")
		.reduce<Entry | undefined>(
			(best, entry) =>
				best === undefined ||
				Date.parse(entry.timestamp) > Date.parse(best.timestamp)
					? entry
					: best,
			undefined,
		);
